<template>
	<div>

		<div>

			<vx-card title="Employee Weekly Hours" class="mb-5">

        <vs-button @click="GenerateReport_EmployeeWeeklyHours('html')">Generate Report (HTML)</vs-button>
        <br/><br/>
        <vs-button @click="GenerateReport_EmployeeWeeklyHours('phantom-pdf')">Generate Report (PDF)</vs-button>

			</vx-card>


		</div>
	</div>
</template>


<script>

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'vue-select/dist/vue-select.css'
const moment = require('moment')


export default{
  components:{
    flatPickr,
    'v-select': vSelect
  },
  data () {
    return {
    }
  },
  computed:{
    isAdmin () {
      return this.$store.getters.GetIsAdmin
    }
  },
  methods: {
   GenerateReport_EmployeeWeeklyHours(type){
     this.$store.dispatch("ActionGenerateReport", type).catch(() => {})
   }
  },
  mounted () {
  }
}

</script>

